jQuery(document).ready(function($) {

    /************************
    * define
    *************************/
    adminUrl = ajax_callback_data.ajax_url;
    // shopUrl = ajaxObj.shop_url;
    
    /*********************
    * validate email
    **********************/
    validateEmail = (email) => {
        return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    /****************
    * loader show
    ****************/
    op_ajax_loader_show = () => {
    	$('.loader').show();
    }
    
    /****************
    * loader hide
    ****************/
    op_ajax_loader_hide = () => {
    	$('.loader').hide();
    }

    /*************************************************
     * span element message after input validation
     *************************************************/
    afrigar_message_element_input_validate = (targetElementId, classError, message) => {
        let inputElement = document.getElementById(targetElementId);
        let spanElement = document.createElement('span');
        spanElement.className = classError;
        spanElement.textContent = message;
        inputElement.insertAdjacentElement('afterend', spanElement);
    }

    /**********************
     * loading - loader
     *********************/
    afrigar_loading = (displayValue) => {
        let loadingIndicator = document.getElementById("loading");
        loadingIndicator.style.display = displayValue;
    }

});